import React, { Component } from "react";
import { Animated } from "react-animated-css";

class WelcomeSection extends Component {
  render() {
    return (
      <div id="particles-js">
        <div className="welcomeText ">
          <h1 className="anchorHome" id="section1" />
          <Animated animationInDelay="2" animationIn="bounceInLeft">
            <h1>
              Hello. My name is{" "}
              <span className="welcomeTextName"> Dylan Gardner.</span>
            </h1>{" "}
            <h1>I am a Full-Stack Web Developer.</h1>{" "}
          </Animated>
        </div>
      </div>
    );
  }
}

export default WelcomeSection;
